import React, { useEffect, useState } from "react";
import logo from "../Assets/Images/logo.jpeg";
import { Link, useLocation, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const [isSticky, setIsSticky] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const { pathname } = useLocation();
  const width = window.innerWidth;

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.remove("active");
    setIsShow(false);
  }, [pathname]);

  useEffect(() => {
    window.addEventListener("scroll", OnScroll);
    return () => window.removeEventListener("scroll", OnScroll);
  }, []);

  const OnScroll = () => setIsSticky(window.scrollY > 100);

  const closeMenu = () => {
    setIsShow(false);
    const menuClickElement = document.getElementById("horizontalMenu-click1");
    if (menuClickElement) menuClickElement.classList.remove("ws-activearrow");
    document.body.classList.remove("active");
  };

  return (
    <div
      className="header-main"
      style={{ minWidth: 375 }}
      onMouseLeave={() => setIsShow(false)}
    >
      <div className="top-bar">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8 col-sm-4 col-7">
              <div className="top-bar-left d-flex">
                <div className="clearfix">
                  <ul className="socials">
                    <li>
                      <a
                        className="social-icon text-dark"
                        target="_blank"
                        href="https://facebook.com/happiedealz"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        className="social-icon text-dark"
                        target="_blank"
                        href="https://instagram.com/happiedealz"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        className="social-icon text-dark"
                        target="_blank"
                        href="https://www.linkedin.com/company/happie-dealz/about/"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-sm-8 col-5">
              <div className="top-bar-right">
                <ul className="custom">
                  <li>
                    <a
                      href="mailto:info@happiedealz.com"
                      target="_blank"
                      className="text-dark"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-envelope me-1"></i>
                      <span>info@happiedealz.com</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`sticky ${isSticky ? "sticky-pin" : ""}`}>
        <div className="horizontal-header clearfix ">
          <div className="container">
            <label
              onClick={() => document.body.classList.toggle("active")}
              id="horizontal-navtoggle"
              className="animated-arrow"
            >
              <span></span>
            </label>
            <span className="smllogo">
              <img
                className="mobile-light-logo"
                src={logo}
                width="120"
                alt=""
              />
            </span>
          </div>
        </div>
      </div>

      <div
        className={`sticky-wrapper ${isSticky ? "is-sticky" : ""}`}
        style={{ height: 80 }}
      >
        <div
          className="horizontal-main clearfix"
          style={isSticky ? { position: "fixed", top: 0 } : {}}
        >
          <div className="horizontal-mainwrapper container clearfix">
            <div className={!isSticky ? "desktoplogo" : "desktoplogo-1"}>
              <Link to={"/"}>
                <img src={logo} alt="" style={{ height: 40 }} />
              </Link>
            </div>

            <nav className="horizontalMenu clearfix d-md-flex">
              <div
                className="overlapblackbg"
                onClick={() => document.body.classList.remove("active")}
              ></div>
              <ul className="horizontalMenu-list">
                <li aria-haspopup="true">
                  <Link
                    to={"/"}
                    className={`text-primary topmenu ${pathname === "/" || pathname === "/home" ? "active" : ""
                      }`}
                    onClick={closeMenu}
                  >
                    <b>Home</b>
                  </Link>
                </li>

                <li aria-haspopup="true">
                  <Link
                    to={"/pricing"}
                    className={`text-primary topmenu ${pathname === "/pricing" ? "active" : ""
                      }`}
                    onClick={closeMenu}
                  >
                    <b>Subscription Plans</b>
                  </Link>
                </li>

                <li aria-haspopup="true">
                  <Link
                    to={"/faq"}
                    className={`text-primary topmenu ${pathname === "/faq" ? "active" : ""
                      }`}
                    onClick={closeMenu}
                  >
                    <b>FAQ</b>
                  </Link>
                </li>

                {localStorage.getItem("token") ? (
                  <li
                    onMouseEnter={() => setIsShow(true)}
                    style={{ position: "relative" }}
                    aria-haspopup="true"
                  >
                    <span
                      className="horizontalMenu-click"
                      id="horizontalMenu-click1"
                      onClick={(e) => {
                        const active =
                          e.currentTarget.classList.toggle("ws-activearrow");
                        setIsShow(active);
                      }}
                    >
                      <i className="horizontalMenu-arrow fa fa-angle-down"></i>
                    </span>
                    <a
                      href="#"
                      className="text-primary topmenu px-2 py-1 align-items-center d-flex"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsShow(!isShow);
                      }}
                    >
                      {width > 720 ? (
                        <i className="fa fa-user-circle fs-20 mb-0" />
                      ) : (
                        <b>Account</b>
                      )}
                      <span className="fa fa-caret-down m-0"></span>
                    </a>

                    <ul
                      className="sub-menu"
                      style={
                        isShow
                          ? {
                            display: "block",
                            opacity: 1,
                            visibility: "visible",
                          }
                          : {
                            display: "none",
                            opacity: 0,
                            visibility: "hidden",
                          }
                      }
                    >
                      <li>
                        <Link
                          to={"/account"}
                          className={pathname === "/account" ? "active" : ""}
                          onClick={closeMenu}
                        >
                          Dashboard
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={"/documentbank"}
                          className={pathname === "/documentbank" ? "active" : ""}
                          onClick={closeMenu}
                        >
                          Document Bank
                        </Link>
                      </li>

                      {/* ✅ Updated View Profile logic */}
                      <li>
                        <label
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const userType =
                              localStorage.getItem("usertypecategory");
                            const username = localStorage.getItem("username");

                            if (!username || !userType) {
                              navigate("/login");
                              return;
                            }

                            if (userType === "Company") {
                              navigate(`/company/${username}`);
                            } else if (userType === "Individual") {
                              navigate(`/individual/${username}`);
                            } else {
                              navigate("/login");
                            }

                            closeMenu();
                          }}
                        >
                          View Profile
                        </label>
                      </li>

                      <li>
                        <Link
                          to={"/profile"}
                          className={pathname === "/profile" ? "active" : ""}
                          onClick={closeMenu}
                        >
                          Edit Profile
                        </Link>
                      </li>

                      <li>
                        <label
                          onClick={() => {
                            localStorage.clear();
                            closeMenu();
                            navigate("/");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Logout
                        </label>
                      </li>
                    </ul>
                  </li>
                ) : (
                  <li aria-haspopup="true">
                    <Link
                      to={"/login"}
                      className={`${width > 720
                        ? "px-2 py-1 align-items-center d-flex"
                        : "text-primary topmenu"
                        } ${pathname === "/login" ? "active" : ""}`}
                      onClick={closeMenu}
                    >
                      {width > 720 ? (
                        <>
                          <i className="fa fa-user-circle fs-20 mb-0" />{" "}
                          <b>Login</b>
                        </>
                      ) : (
                        <b>Login</b>
                      )}
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;